import React, { useState, useEffect, useContext } from "react";
import { graphql } from "gatsby";
import ContentReferenceCard from "../../molecules/Cards/ContentReference";
import { removeUnderscores } from "../../../utils/miscUtils";
import { Container, Row, Col } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import Spinner from "react-bootstrap/Spinner";
import { AppContext } from "../../../context/appContext";

export const ParagraphListingPageTemplate = ({ node }) => {
  const { localSearchContentTypes } = useContext(AppContext);
  const [isLoading, setIsLoading] = useState(true);
  const [results, setResults] = useState();
  const sortedStoreArray = Object?.values(
    localSearchContentTypes?.store || {}
  )?.sort(
    (a, b) => new Date(b?.field_published) - new Date(a?.field_published)
  );

  useEffect(() => {
    let filteredData = [];

    if (node?.relationships?.field_listing_type?.name === "Feature") {
      filteredData = sortedStoreArray.filter((ct) => {
        if (
          ct?.field_product_tags?.id ===
          node?.relationships?.field_listing_type?.id
        ) {
          return ct;
        }
        if (ct?.type === "shorthand") {
          return ct;
        }
        return null;
      });
    } else {
      filteredData = sortedStoreArray.filter(
        (ct) =>
          ct?.field_product_tags?.id ===
          node?.relationships?.field_listing_type?.id
      );
    }

    setResults(filteredData || []);
  }, []);

  //# PAGINATION LOGIC
  const [itemOffset, setItemOffset] = useState(0);
  const itemsPerPage = 18;
  const endOffset = itemOffset + itemsPerPage;
  const currentItems = results?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(results?.length / itemsPerPage);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % results?.length;
    setItemOffset(newOffset);

    if (window) {
      window.scrollTo(0, 0);
    }
  };

  useEffect(() => {
    setIsLoading(false);
  }, [results, currentItems]);

  if (isLoading) {
    return (
      <div className="d-flex justify-content-center my-5rem">
        <Spinner animation="border" variant="secondary" />
      </div>
    );
  }

  return (
    <Container className="general-container">
      <Row className="results-container">
        {results?.length > 0 &&
          currentItems?.map((node) => {
            const linkTo =
              node?.type === "good_practice"
                ? `/good-practice/?id=${node?.field_practice_id}`
                : node?.slug?.alias || node?.slug;
            return (
              <Col xs={12} md={6} xl={4} className="mb-5">
                <ContentReferenceCard
                  title={node?.title}
                  imageURL={node?.field_image?.gatsbyImage}
                  eyebrowText={
                    node?.field_product_tags?.name ||
                    removeUnderscores(node?.type)
                  }
                  authorDetails={node?.field_authors}
                  field_theme={node?.field_theme}
                  field_region={node?.field_region}
                  field_country={node?.field_country}
                  linkTo={linkTo}
                  fieldPublished={node?.field_published}
                  fieldEventPlace={node?.field_event_place}
                  fieldTimeFrame={node?.field_time_frame}
                  fieldSubtitle={node?.field_subtitle?.value}
                  body={node?.body}
                />
              </Col>
            );
          })}
      </Row>

      {results?.length > 0 && results.length > 18 && (
        <Row>
          <Col xs={12}>
            <ReactPaginate
              className="custom-pagination"
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={2}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="<"
              renderOnZeroPageCount={null}
              activeClassName="selected-active"
            />
          </Col>
        </Row>
      )}
    </Container>
  );
};

export const fragment = graphql`
  fragment ParagraphListingPageTemplate on paragraph__listing_page_template {
    id
    relationships {
      field_listing_type {
        name
        id
      }
    }
  }
`;

export default ParagraphListingPageTemplate;
